module.exports = __webpack_public_path__ + "static/img/h3-3.710ed16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/h3-3.png
// module id = 1a7f
// module chunks = 1